(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-card-tabs"] && !window.DesignMode) return;
  try {
    
  const tabPdButtons = document.querySelectorAll('.product-tab-button');
  const productTabContainers = document.querySelectorAll('.product-tab-container');

  tabPdButtons.forEach((button) => {
    button.addEventListener('click', () => {
      // Remove 'active' from all buttons
      tabPdButtons.forEach((btn) => btn.classList.remove('active'));
      // Add 'active' to clicked button
      button.classList.add('active');

      // Hide all containers
      productTabContainers.forEach((container) => container.classList.remove('active'));

      // Show the one with matching id
      const target = button.getAttribute('data-tab');
      document.getElementById(target).classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !window.DesignMode) return;
  try {
    
  let swiper_config = {
    slidesPerView:1.4,
      spaceBetween: 20,
      breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 20
      },
      1280: {
        slidesPerView:3.5,
        spaceBetween: 20
      },
      1536: {
        slidesPerView: 4.5,
        spaceBetween: 20
      },
    }
  }
    var swipercards1 = new Swiper(".product-tab-container.slider1", {
      ...swiper_config,
       pagination: {
        el: ".slidebar1",
        type: "progressbar",
      },
    });
    var swipercards2 = new Swiper(".product-tab-container.slider2", {
     ...swiper_config,
       pagination: {
        el: ".slidebar2",
        type: "progressbar",
      },
    });
    var swipercards3 = new Swiper(".product-tab-container.slider3", {
     ...swiper_config,
       pagination: {
        el: ".slidebar3",
        type: "progressbar",
      },
    });
  const tabPdButtons = document.querySelectorAll('.product-tab-button');
  const productTabContainers = document.querySelectorAll('.product-tab-container');

  tabPdButtons.forEach((button) => {
    button.addEventListener('click', () => {
      // Remove 'active' from all buttons
      tabPdButtons.forEach((btn) => btn.classList.remove('active'));
      // Add 'active' to clicked button
      button.classList.add('active');

      // Hide all containers
      productTabContainers.forEach((container) => container.classList.remove('active'));

      // Show the one with matching id
      const target = button.getAttribute('data-tab');
      document.getElementById(target).classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
